exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".aeris-notifier-host{display:block;position:absolute;z-index:9999;top:0;left:50%;transform:translateX(-50%)}.aeris-notifier-host .notification{list-style-type:none}.aeris-notifier-host .aeris-notifier-container{display:flex;flex-direction:column}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-7701cd00","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/aeris-notification/aeris-notifier.vue
// module id = 163
// module chunks = 0